import runStrategies from 'Utils/run-strategies';
import notificationTextClickStrategies from 'Webapp/shared/app/components/notifications/notification-text-click-strategies';

export default runStrategies(notificationTextClickStrategies);
